<div class="card" >
  <div class="card-body">
    <app-doc-fill-info-bci *ngIf="isBCI" [onboardingDocUserId]="onboardingDocUserId"> </app-doc-fill-info-bci>
    <app-doc-fill-info-criminal-background *ngIf="isCriminalBackgorundScreening" [onboardingDocUserId]="onboardingDocUserId"> </app-doc-fill-info-criminal-background>
    <app-doc-fill-info-prism-provider-agreement *ngIf="isPRISMProviderAgreement" [onboardingDocUserId]="onboardingDocUserId"> </app-doc-fill-info-prism-provider-agreement>
    <app-doc-fill-info-i9form *ngIf="isI9Form" [onboardingDocUserId]="onboardingDocUserId" [doNotNavigate]="false"> </app-doc-fill-info-i9form>
    <app-doc-fill-info-w4form *ngIf="isW4Form" [onboardingDocUserId]="onboardingDocUserId" [doNotNavigate]="false"> </app-doc-fill-info-w4form>
  </div>
</div>
